import { isNull, truncate } from 'lodash';
import { showCarousel } from './carousel';

class InstagramFeed {
  constructor() {
    this.init();
  }

  init() {
    const userFeed = new Instafeed({
      get: 'user',
      target: 'instafeed',
      resolution: 'low_resolution',
      transform(image) {
        image.caption = truncate(image.caption, {
          length: 120,
          omission: '&hellip;',
        });
        return image;
      },
      template: `<div>
          <a class="image-hover d-block" target="_blank" href="{{ link }}">
            <img title="{{ caption }}" src="{{ image }}" />
          </a>
        </div>`,
      accessToken: `${window.instagramAccessToken}`,
      after: () => {
        showCarousel('instagram');
      },
    });
    userFeed.run();
  }
}

document.addEventListener('DOMContentLoaded', () => {
  // check if instafeed id exist or not on current page
  const instafeed = document.querySelector('#instafeed');

  if (!isNull(instafeed) && typeof Instafeed === 'function') {
    new InstagramFeed();
  }
});
